import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listWorkflowCaseRetainedArtifacts } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'
import {
  ListWorkflowCaseRetainedArtifactsRequestSchema,
  type ListWorkflowCaseRetainedArtifactsResponse,
} from '@ebalance/proto/bffuser/v1/workflow_case_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useListWorkflowCaseRetainedArtifacts(
  caseId: string | undefined,
  enabled: boolean,
): UseQueryResult<ListWorkflowCaseRetainedArtifactsResponse, ConnectError> {
  return useQuery(
    listWorkflowCaseRetainedArtifacts,
    create(ListWorkflowCaseRetainedArtifactsRequestSchema, {
      workflowCaseId: caseId ?? '',
    }),
    { enabled: enabled && caseId !== undefined && caseId !== '' },
  )
}
